import { CmsSellerFilters, CustomCmsSeller } from '../../../../domain/seller'
import NaverMapSellersPage from './NaverMapSellersPage'
import { useLoadNaverMapApi } from './helpers'

export const NaverMapSellersPageLoadApi = ({
  sellers,
  onSubmitFilterForm,
  filters,
}: {
  sellers: CustomCmsSeller[]
  onSubmitFilterForm: (value: CmsSellerFilters) => void
  filters: CmsSellerFilters
}) => {
  const isLoaded = useLoadNaverMapApi()

  if (!isLoaded) {
    return null
  }

  return (
    <NaverMapSellersPage
      sellers={sellers}
      onSubmitFilterForm={onSubmitFilterForm}
      filters={filters}
    />
  )
}
